/** Traductions gestionnaire de sessions worker (FR / AR) */
export const workerSessionManagerFr = {
  notSpecified: 'Non spécifié',
  sessionsLoadError: 'Erreur lors du chargement des sessions',
  refreshSessions: 'Actualiser les sessions',
  notAvailable: 'N/D',
  allEmployees: 'Tous les employés',
  fromDatePrefix: 'À partir du',
  sessionReportTitle: 'Rapport des Sessions',
  employee: 'Employé',
  period: 'Période',
  sessionCount: 'Nombre de sessions',
  startDate: 'Date de début',
  endDate: 'Date de fin',
  initialAmount: 'Montant initial',
  finalAmount: 'Montant final',
  sales: 'Ventes',
  status: 'Statut',
  sessionCol: 'N°',
  sessionNumber: 'Session {{n}}',
  inProgress: 'En cours',
  pendingClose: 'Non clôturée',
  completed: 'Terminée',
  active: 'Active',
  pendingSettlement: 'À clôturer',
  filters: 'Filtres',
  sessionReportFullTitle: 'Rapport des Sessions des Employés',
  workerIdCol: 'ID Employé',
  workerNameCol: 'Nom Employé',
  dateCol: 'Date',
  startTimeCol: 'Heure de Début',
  endTimeCol: 'Heure de Fin',
  ecartCol: 'Écart',
  allWorkers: 'Tous les employés',
  fromDateLabel: 'Date de début',
  toDateLabel: 'Date de fin',
  clearFilters: 'Effacer les filtres',
  ecarts: 'Écarts',
  monthlyEcarts: 'Écarts du mois',
  sessionEcartShort: 'Session',
  cumulativeShort: 'Cumul',
  modalTableCaption: 'Résumé de la session',
  modalRowOpen: 'Début caisse',
  modalRowClose: 'Fin comptée',
  modalRowSales: 'Ventes',
  modalRowExpected: 'Attendu',
  modalRowOut: 'Sorties',
  modalRowEcart: 'Écart',
  modalRowMonth: 'Mois (total)',
  modalRowHandover: 'Passation',
  modalRowPayments: 'Paiements',
  modalSalesCount: '{{count}} vente(s)',
  closeModal: 'Fermer',
  modalOverview: 'Vue d\'ensemble',
  modalOverviewHint: 'Les chiffres essentiels de cette session de caisse.',
  modalHandover: 'Passation de caisse',
  modalHandoverHint: 'Le collègue précédent a déclaré un montant à la fermeture ; vous avez compté au début.',
  predecessorLeft: 'A laissé en caisse',
  youStarted: 'Vous avez compté',
  handoverGap: 'Écart de passation',
  noHandover: 'Pas de passation enregistrée (première session ou même caissier).',
  modalEcarts: 'Écarts enregistrés',
  modalEcartsHint: 'Écarts validés par le manager — cumul du mois jusqu\'à cette session.',
  sessionEcartLabel: 'Écart de cette session',
  cumulativeMonthLabel: 'Cumul du mois (jusqu\'ici)',
  cumulativeIncludesPrevious: 'Dont {{amount}} sur {{count}} écart(s) des sessions précédentes du mois.',
  recordedEcartDiffers: 'Écart enregistré à la déconnexion : {{amount}} (peut différer si les données ont changé).',
  noRecordedEcart: 'Aucun',
  showSalesDetails: 'Voir le détail des ventes et calculs',
  hideSalesDetails: 'Masquer le détail des ventes',
  ecartSollExplain: 'Cash réel en fin de session moins le montant attendu.',
  actions: 'Actions',
  noSessions: 'Aucune session trouvée',
  count: 'Nombre',
  viewDetails: 'Voir les détails',
  totalSales: 'Total ventes',
  cashIssues: 'Problèmes de caisse',
  duration: 'Durée',
  sessionDetails: 'Détails de la Session',
  previousSession: 'Session précédente',
  nextSession: 'Session suivante',
  workerInfo: 'Informations du Travailleur',
  name: 'Nom',
  id: 'ID',
  sessionTimes: 'Horaires de la Session',
  start: 'Début',
  end: 'Fin',
  financialSummary: 'Résumé Financier',
  salesDetails: 'Détails des Ventes',
  unknownCustomer: 'Client Inconnu',
  productsSold: 'Produits Vendus',
  unknownProduct: 'Produit Inconnu',
  paymentMethodsSummary: 'Résumé des Méthodes de Paiement',
  operations: 'opérations',
  predecessorInfo: 'Informations du Prédécesseur',
  predecessor: 'Prédécesseur',
  amountGap: 'Écart entre les montants',
  increase: '(Augmentation)',
  decrease: '(Diminution)',
  differencesAndCalculations: 'Différences et Calculs',
  cashDifference: 'Différence de Caisse',
  ecartSoll: 'Écart Soll (réel − attendu)',
  expectedCash: 'Montant attendu (espèces)',
  cashOutgoing: 'Sorties espèces — total',
  cashPaymentsOutgoing: 'Paiements fournisseurs (espèces)',
  cashExpensesOutgoing: 'Dépenses (espèces)',
  cashSalesOnly: 'Ventes en espèces seulement',
  predecessorEcart: 'Écart avec le Prédécesseur',
  loading: 'Chargement...',
  cash: 'Espèces',
  timesSeparator: '×',
  manageSessions: 'Gérer les Sessions',
  allSessions: 'Toutes les Sessions',
  workerSessionsTitle: 'Sessions du Travailleur',
  hide: 'Masquer',
  show: 'Voir',
  noSessionsTitle: 'Aucune session',
  noSessionsAllHint: 'Aucune session enregistrée',
  noSessionsWorkerHint: 'Aucune session enregistrée pour cet employé',
  sessionsPanelTitle: 'Sessions de travail',
  sessionsPanelDesc: 'Historique des connexions par employé',
  liveBadge: 'Direct',
  expectedCashCol: 'Montant attendu',
  cashOutgoingCol: 'Sorties espèces',
  electronicEcart: 'Écart électronique',
  electronicStart: 'Début électronique',
  electronicEnd: 'Fin électronique',
  salesCount: 'Nb ventes',
  electronicByProvider: 'Ventes électroniques par fournisseur',
  expectedElectronicCol: 'Attendu électronique',
  electronicOutgoingCol: 'Sorties électroniques',
  totalEcart: 'Écart total',
  modalRowElectronicOpen: 'Début électronique',
  modalRowElectronicClose: 'Fin électronique comptée',
  modalRowCashSales: 'Ventes espèces',
  modalRowElectronicSales: 'Ventes électroniques',
  modalRowExpectedElectronic: 'Attendu électronique',
  modalRowElectronicEcart: 'Écart électronique',
  modalRowTotalEcart: 'Écart total',
  modalCalcDetail: 'Calcul détaillé (attendu vs réel)',
  initialTotalCol: 'Initial total',
  expectedTotalCol: 'Attendu total',
  finalTotalCol: 'Final total',
  outgoingTotalCol: 'Sorties total',
  sessionEcartCol: 'Écart session',
  cumulativeCol: 'Cumul',
  clickForDetail: 'Cliquer pour le détail espèces / électronique',
  modalSummaryTitle: 'Synthèse de la session'
};

export const workerSessionManagerAr = {
  notSpecified: 'غير محدد',
  sessionsLoadError: 'خطأ في تحميل الجلسات',
  refreshSessions: 'تحديث الجلسات',
  notAvailable: 'غير متوفر',
  allEmployees: 'جميع الموظفين',
  fromDatePrefix: 'ابتداءً من',
  sessionReportTitle: 'تقرير الجلسات',
  employee: 'الموظف',
  period: 'الفترة',
  sessionCount: 'عدد الجلسات',
  startDate: 'تاريخ البدء',
  endDate: 'تاريخ الانتهاء',
  initialAmount: 'المبلغ الأولي',
  finalAmount: 'المبلغ النهائي',
  sales: 'المبيعات',
  status: 'الحالة',
  sessionCol: 'رقم',
  sessionNumber: 'جلسة {{n}}',
  inProgress: 'جارية',
  pendingClose: 'غير مغلقة',
  completed: 'مكتملة',
  active: 'نشطة',
  pendingSettlement: 'بانتظار الإغلاق',
  filters: 'المرشحات',
  sessionReportFullTitle: 'تقرير جلسات الموظفين',
  workerIdCol: 'معرف الموظف',
  workerNameCol: 'اسم الموظف',
  dateCol: 'التاريخ',
  startTimeCol: 'وقت البدء',
  endTimeCol: 'وقت الانتهاء',
  ecartCol: 'الانحراف',
  allWorkers: 'جميع الموظفين',
  fromDateLabel: 'من تاريخ',
  toDateLabel: 'إلى تاريخ',
  clearFilters: 'مسح المرشحات',
  ecarts: 'الاختلافات',
  monthlyEcarts: 'الاختلافات الشهرية',
  sessionEcartShort: 'الجلسة',
  cumulativeShort: 'المجموع',
  modalTableCaption: 'ملخص الجلسة',
  modalRowOpen: 'افتتاح الصندوق',
  modalRowClose: 'الإغلاق',
  modalRowSales: 'المبيعات',
  modalRowExpected: 'المتوقع',
  modalRowOut: 'المصروفات',
  modalRowEcart: 'الفرق',
  modalRowMonth: 'مجموع الشهر',
  modalRowHandover: 'التسليم',
  modalRowPayments: 'طرق الدفع',
  modalSalesCount: '{{count}} عملية',
  closeModal: 'إغلاق',
  modalOverview: 'نظرة عامة',
  modalOverviewHint: 'الأرقام الأساسية لهذه الجلسة.',
  modalHandover: 'تسليم الصندوق',
  modalHandoverHint: 'المبلغ الذي أعلنه الزميل السابق عند الإغلاق وما عدّلته عند البدء.',
  predecessorLeft: 'ترك في الصندوق',
  youStarted: 'عدت عند البدء',
  handoverGap: 'فرق التسليم',
  noHandover: 'لا يوجد تسليم مسجل.',
  modalEcarts: 'الاختلافات المسجلة',
  modalEcartsHint: 'اختلافات المدير — المجموع التراكمي للشهر حتى هذه الجلسة.',
  sessionEcartLabel: 'اختلاف هذه الجلسة',
  cumulativeMonthLabel: 'مجموع الشهر (حتى هنا)',
  cumulativeIncludesPrevious: 'منها {{amount}} من {{count}} اختلاف(ات) للجلسات السابقة.',
  recordedEcartDiffers: 'فرق مسجل عند تسجيل الخروج: {{amount}} (قد يختلف إذا تغيّرت البيانات).',
  noRecordedEcart: 'لا يوجد',
  showSalesDetails: 'عرض تفاصيل المبيعات والحسابات',
  hideSalesDetails: 'إخفاء تفاصيل المبيعات',
  ecartSollExplain: 'النقد الفعلي في نهاية الجلسة ناقص المبلغ المتوقع.',
  actions: 'الإجراءات',
  noSessions: 'لا توجد جلسات',
  count: 'عدد',
  viewDetails: 'عرض التفاصيل',
  totalSales: 'إجمالي المبيعات',
  cashIssues: 'مشاكل في النقد',
  duration: 'المدة',
  sessionDetails: 'تفاصيل الجلسة',
  previousSession: 'الجلسة السابقة',
  nextSession: 'الجلسة التالية',
  workerInfo: 'معلومات الموظف',
  name: 'الاسم',
  id: 'المعرف',
  sessionTimes: 'أوقات الجلسة',
  start: 'البداية',
  end: 'النهاية',
  financialSummary: 'الملخص المالي',
  salesDetails: 'تفاصيل المبيعات',
  unknownCustomer: 'عميل غير معروف',
  productsSold: 'المنتجات المباعة',
  unknownProduct: 'منتج غير معروف',
  paymentMethodsSummary: 'ملخص طرق الدفع',
  operations: 'عملية',
  predecessorInfo: 'معلومات السلف',
  predecessor: 'السلف',
  amountGap: 'الفرق في المبالغ',
  increase: '(زيادة)',
  decrease: '(نقصان)',
  differencesAndCalculations: 'الاختلافات والحسابات',
  cashDifference: 'فرق الصندوق',
  ecartSoll: 'فرق المبلغ المتوقع (سول)',
  expectedCash: 'المبلغ المتوقع (نقداً)',
  cashOutgoing: 'صادر نقداً — الإجمالي',
  cashPaymentsOutgoing: 'مدفوعات الموردين (نقداً)',
  cashExpensesOutgoing: 'المصروفات (نقداً)',
  cashSalesOnly: 'مبيعات نقداً فقط',
  predecessorEcart: 'التناقض مع الموظف السابق',
  loading: 'جاري التحميل...',
  cash: 'نقداً',
  timesSeparator: '×',
  manageSessions: 'إدارة الجلسات',
  allSessions: 'جميع الجلسات',
  workerSessionsTitle: 'جلسات الموظف',
  hide: 'إخفاء',
  show: 'عرض',
  noSessionsTitle: 'لا توجد جلسات',
  noSessionsAllHint: 'لم يتم تسجيل أي جلسات بعد',
  noSessionsWorkerHint: 'لم يتم تسجيل أي جلسات لهذا الموظف بعد',
  sessionsPanelTitle: 'جلسات العمل',
  sessionsPanelDesc: 'سجل الدخول والنشاط حسب الموظف',
  liveBadge: 'مباشر',
  expectedCashCol: 'المبلغ المتوقع',
  cashOutgoingCol: 'صادر نقداً',
  electronicEcart: 'فرق الإلكتروني',
  electronicStart: 'بداية الإلكتروني',
  electronicEnd: 'نهاية الإلكتروني',
  salesCount: 'عدد المبيعات',
  electronicByProvider: 'مبيعات إلكترونية حسب المزود',
  expectedElectronicCol: 'المتوقع إلكترونياً',
  electronicOutgoingCol: 'صادر إلكتروني',
  totalEcart: 'إجمالي الفرق',
  modalRowElectronicOpen: 'بداية الإلكتروني',
  modalRowElectronicClose: 'نهاية الإلكتروني المحسوبة',
  modalRowCashSales: 'مبيعات نقداً',
  modalRowElectronicSales: 'مبيعات إلكترونية',
  modalRowExpectedElectronic: 'المتوقع إلكترونياً',
  modalRowElectronicEcart: 'فرق الإلكتروني',
  modalRowTotalEcart: 'إجمالي الفرق',
  modalCalcDetail: 'حساب مفصل (متوقع مقابل فعلي)',
  initialTotalCol: 'الافتتاح الإجمالي',
  expectedTotalCol: 'المتوقع الإجمالي',
  finalTotalCol: 'الإغلاق الإجمالي',
  outgoingTotalCol: 'المصروفات الإجمالية',
  sessionEcartCol: 'فرق الجلسة',
  cumulativeCol: 'المجموع التراكمي',
  clickForDetail: 'انقر للتفاصيل (نقداً / إلكتروني)',
  modalSummaryTitle: 'ملخص الجلسة'
};
